import classes from '../styles/Page.module.scss';
import client from './api/graphql';
import { GET_FEATURES_CONTENT } from './api/graphql/queries';
import Features from '../components/sections/features/Features.js';
import Channels from '../components/sections/channels/Channels.js';
import Music from '../components/sections/music/Music.js';
import Games from '../components/sections/games/Games.js';
import PageHeader from '../components/organisms/pageHeader/PageHeader';
import Subfooter from '../components/organisms/subfooter/Subfooter';
import { redirectedPtAndArToEnglish } from '../utils/functions';

/**
 * Ayoba Web Features Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FeaturesPage = (props) => {
    /**
     * Section content
     */
    const { feature, landingPages } = props?.data;
    const { page_header, app_feature, channels, music, games, app_feature_momo, app_feature_apps } =
        feature?.data?.attributes;

    return (
        <div className={classes.oFeaturesPage}>
            <PageHeader {...page_header} />
            <Features {...app_feature} />
            <Channels {...channels} />
            <Music {...music} />
            <Games {...games} />
            <Features {...app_feature_momo} />
            <div className={classes.aFeatureSpacer}></div>
            <Features {...app_feature_apps} />
            <Subfooter {...landingPages} />
        </div>
    );
};

export async function getServerSideProps(context) {
    let locale = context.query?.lang || context.defaultLocale;
    locale = redirectedPtAndArToEnglish(locale)

    const { data } = await client.query({
        query: GET_FEATURES_CONTENT,
        variables: { _locale: locale }
    });

    return {
        props: { data }
    };
}

export default FeaturesPage;
